export default __webpack_public_path__ + "locales/uk-UA/DataReassignmentDialog.json?hash=40bddb6947c893a3544652c553e9b1bd";